import { Component, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InputTextComponent } from '../input-text/input-text.component';
import { FormRowLayout } from '../form-row/form-row.component';

/**
 * THE admin address block: Address Line 1, Address Line 2, Post Code,
 * Region and City as stacked label+input rows — the approved store-details
 * shape. One shared definition instead of per-screen forks: the forked
 * `address-multi` rows squeezed Post Code / Region / City onto one cramped
 * line on the tables and billing screens.
 *
 * Screens that attach Google Places autocomplete reach the raw line-1
 * <input> via `line1Cmp.bareInput` (see store-form). Line 1 keeps the
 * fixed `address-search-box-autocomplete` id those hooks key on unless the
 * host overrides `line1InputId` (a second instance on one page MUST
 * override it).
 */
@Component({
  selector: 'app-address-fields',
  templateUrl: './address-fields.component.html',
})
export class AddressFieldsComponent {
  @Input() line1Control!: FormControl;
  @Input() line2Control!: FormControl;
  @Input() postCodeControl!: FormControl;
  @Input() regionControl!: FormControl;
  @Input() cityControl!: FormControl;

  @Input() line1Required = false;
  @Input() postCodeRequired = false;
  @Input() cityRequired = false;

  /** Column preset for the sub-rows; all simple presets resolve to the
   *  admin-wide standard, so this rarely needs changing. */
  @Input() layout: FormRowLayout = 'address';

  /** Prefix for the line2/postCode/region/city input ids (id collisions
   *  when a page renders two address blocks). */
  @Input() idPrefix = '';

  @Input() line1InputId = 'address-search-box-autocomplete';

  @ViewChild('line1Cmp') line1Cmp?: InputTextComponent;

  id(name: string): string {
    return this.idPrefix ? `${this.idPrefix}-${name}` : name;
  }
}
